export default __webpack_public_path__ + "static/media/health_check_female_Cn.192e31d4.webp";